import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DashboardContext from "../../../Context";
import Loader from "../../layout/Loader";
import { useHistory } from "react-router-dom";
/** 
 * این کامپوننت برای نمایش مدال جزئیات سفارش  است که در جدول سفارشات است
*/
const ModalDetial = ({ id, handelclosemodal, showitem, url }) => {
    const { location } = useHistory()
    const { urldashboard, authentication, handelerrors } = useContext(DashboardContext);

    const [loding, setLoding] = useState(false);

    const [dataFech, setDataFech] = useState({})

    const [controllerName, setControllerName] = useState(location.pathname.split('/')[1].replace('/',''));
    useEffect(() => {
       
        var changeControllerName=controllerName;

        if (location.pathname.includes("Customer")) 
        {
          
            setControllerName("order");
            changeControllerName="order";
        }   

    const dataFeching = async () => {
        setLoding(true)
        try {
            const res = await Axios.get(`${urldashboard}/${url ? url : changeControllerName}/detial/${id}`, {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })
            const data = await res.data.data
            setDataFech(data);
            setLoding(false);
        } catch (error) {
            setLoding(false)
            handelclosemodal();
            handelerrors(error);
        }
    }
  


        dataFeching()
        return () => {

        }
    }, [id])


    return (
        <Modal show={showitem} onHide={handelclosemodal} >

            <Modal.Header>
                <Modal.Title>مشاهد جزئیات </Modal.Title>
                <i className="fa fa-times mr-auto" style={{ fontSize: '16px', cursor: 'pointer' }} onClick={handelclosemodal} aria-hidden="true"></i>

            </Modal.Header>
            <Modal.Body>
                {
                    loding ? <Loader />
                        : <div>
                            <p>نام مشتری : <span>{dataFech.customerName}</span></p>
                            <p>شماره تماس : <span>{dataFech.cellPhone}</span></p>
                            <p>آدرس مشتری : <span>{dataFech.address}</span></p>
                            <p>نوع اپلیکیشن : <span>{dataFech.appTypeTitle}</span></p>
                            <p>شرکت : <span>{dataFech.companyTypeTitle}</span></p>
                            <p>وضعیت : <span>{dataFech.isActive ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                            <p>نام گروه : <span>{dataFech.groupName}</span></p>
                            <p>هزینه سایر خدمات :{dataFech.additionalServiceAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.additionalServiceAmount)} <small>ريال</small></span> : null} </p>
                            <p>توضیحات لغو : <span>{dataFech.cancelDescription}</span></p>
                            <p>ظرفیت نیرو ها؟ : <span>{dataFech.CapacityIsComplete ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                            <p>پورسانت ثابت : <span>{dataFech.commission}</span></p>
                            <p>تایید مشتری : <span>{dataFech.customerApproved ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                            <p>توضیحات : <span>{dataFech.description}</span></p>
                            <p>مبلغ تخفیف فاکتور : {dataFech.discountAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.discountAmount)} <small>ريال</small></span> : null}</p>
                            <p>توضیحات نیروی مورد علاقه : <span>{dataFech.favoriteDescription}</span></p>
                            <p>هزینه نیروی خانم :{dataFech.femaleAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.femaleAmount)} <small>ريال</small></span> : null}</p>
                            <p>هزینه نیروی آقا : {dataFech.maleAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.maleAmount)} <small>ريال</small></span> : null}</p>
                            <p>پورسانت پرستاری : {dataFech.commissionAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.commissionAmount)} <small>ريال</small></span> : null}</p>
                            <p>تخفیف کارگر خانم : <span>{dataFech.femaleDiscountAmount}</span></p>
                            <p>تخفیف کارگر آقا : <span>{dataFech.MaleDiscountAmount}</span></p>
                            <p>تعداد کارگر خانم : <span>{dataFech.numberFemaleWorker}</span></p>
                            <p>تعداد کارگر آقا : <span>{dataFech.numberMaleWorker}</span></p>
                            <p>نام نیرو ها : <span>{dataFech.workerNames}</span></p>
                            <p>خدمات اضافه : <span>{dataFech.groupOptionTitle}</span></p>
                            <p>وضعیت سفارش : <span>{dataFech.orderStatusTitle}</span></p>
                            <p>تاریخ ثبت : <span>{dataFech.persianCreateDate}</span></p>
                            <p>تاریخ شروع : <span>{dataFech.persianStartWork}</span></p>
                            <p>تاریخ پایان : <span>{dataFech.persianEndWork}</span></p>
                            <p>مدت زمان کار : <span>{dataFech.periodTime} <small>ساعت</small></span></p>
                            <p>نوع پرداخت : <span>{dataFech.paymentTypeTitle}</span></p>
                            <p>هزینه کل : {dataFech.totalAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.totalAmount)} <small>ريال</small></span> : null}</p>
                            <p>هزینه قابل پرداخت : {dataFech.payableAmount ? <span>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(dataFech.payableAmount)} <small>ريال</small></span> : null}</p>
                            <p>کد پیگیری : <span>{dataFech.trackingCode}</span></p>
                            <p>ثبت کننده : <span>{dataFech.userCreator}</span></p>
                            <p>پیگیری کننده : <span>{dataFech.userUpdate}</span></p>
                            <p>وضعیت لغو : <span>{dataFech.isCanceled ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                            <p>وضعیت پرداخت : <span>{dataFech.isPaid ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                            <p>سفارش دوره ی : <span>{dataFech.isPeriod ? <i style={{ color: 'green' }} className="fa fa-check"></i>
                                : <i style={{ color: 'red' }} className="fa fa-times"></i>}</span></p>
                        </div>
                }
            </Modal.Body>
            <Modal.Footer >
                <Button className='mx-auto' variant='danger' onClick={handelclosemodal} >بستن</Button>
            </Modal.Footer>
        </Modal >
    );
}

export default ModalDetial;
